import { useState, useRef, useCallback } from 'react';
import { Mic, MicOff } from 'lucide-react';

const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

export function VoiceInput({ onResult, lang = 'de-DE', className = '' }) {
  const [listening, setListening] = useState(false);
  const recRef = useRef(null);

  const toggle = useCallback(() => {
    if (!SpeechRecognition) {
      alert('Spracherkennung wird von diesem Browser nicht unterstützt. Bitte Chrome, Edge oder Safari verwenden.');
      return;
    }

    if (listening && recRef.current) {
      recRef.current.stop();
      return;
    }

    const rec = new SpeechRecognition();
    rec.lang = lang;
    rec.continuous = true;
    rec.interimResults = false;

    rec.onresult = (e) => {
      const transcript = Array.from(e.results)
        .slice(e.resultIndex)
        .map(r => r[0].transcript)
        .join('');
      if (transcript.trim()) onResult(transcript);
    };

    rec.onend = () => setListening(false);
    rec.onerror = () => setListening(false);

    recRef.current = rec;
    rec.start();
    setListening(true);
  }, [listening, lang, onResult]);

  if (!SpeechRecognition) return null;

  return (
    <button
      type="button"
      onClick={toggle}
      title={listening ? 'Aufnahme stoppen' : 'Spracheingabe starten'}
      className={`inline-flex items-center justify-center rounded-lg transition-all ${
        listening
          ? 'bg-red-500/15 text-red-500 animate-pulse'
          : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:bg-white/10 dark:hover:text-white/70'
      } ${className}`}
      style={{ touchAction: 'manipulation' }}
      data-testid="voice-input-btn"
    >
      {listening ? <MicOff className="w-4 h-4" /> : <Mic className="w-4 h-4" />}
    </button>
  );
}
